import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField", "option", "feedback", "feedbackText", "container"]

  connect() {
    // Verificar o estado inicial das opções
    if (this.hasHiddenFieldTarget) {
      this.initFromExistingValue()
    } else {
      console.error("Hidden field target not found - check your HTML structure")
    }
  }

  initFromExistingValue() {
    // Verifica se já existe um valor no campo oculto
    const currentValue = this.hiddenFieldTarget.value
    
    if (currentValue) {
      // Encontra o radio button correspondente e marca como checado
      const option = this.optionTargets.find(opt => opt.value === currentValue)
      if (option) {
        option.checked = true
        this.updateFeedback(option)
      } else {
        console.warn("No option found matching value:", currentValue)
      }
    } else {
      // Se não há valor, marca a opção "None" como selecionada
      const noneOption = this.optionTargets.find(opt => opt.value === "")
      if (noneOption) {
        noneOption.checked = true
      }
    }
  }

  updateValue(event) {
    if (!this.hasHiddenFieldTarget) {
      console.error("Cannot update value: Hidden field target not found!")
      return
    }
    
    const selectedValue = event.currentTarget.value
    
    // Atualiza o campo oculto com o valor selecionado
    this.hiddenFieldTarget.value = selectedValue
    
    // Garante que o formulário reconhece a mudança
    this.hiddenFieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
    
    // Atualiza o feedback visual
    this.updateFeedback(event.currentTarget)
    
  }

  updateFeedback(selectedOption) {
    if (!this.hasFeedbackTarget || !this.hasFeedbackTextTarget) return
    
    if (selectedOption.value) {
      // Pega o texto do badge dentro do label associado ao radio selecionado
      const label = document.querySelector(`label[for="${selectedOption.id}"]`)
      if (label) {
        const badgeText = label.querySelector(".quartile-badge").textContent.trim()
        
        // Atualiza o texto de feedback
        this.feedbackTextTarget.textContent = badgeText
        
        // Mostra o feedback
        this.feedbackTarget.style.display = "block"
      }
    } else {
      // Esconde o feedback se "None" for selecionado
      this.feedbackTarget.style.display = "none"
    }
  }
}
